<form [formGroup]="coCurricularForm" class="max-w-5xl space-y-4" (ngSubmit)="saveCoCurricular()">
  <details [open]="openSection === 'paperPresentation'" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('paperPresentation', $event)">
      <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
      Paper Presentation
    </summary>
    <div class="mt-3 space-y-4" formArrayName="paperPresentations">
      @for (paper of paperPresentations.controls; track paper; let i = $index) {
        <div class="relative bg-zinc-100 border rounded-md p-6 space-y-4" [formGroupName]="i">
          @if (i > 0) {
            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove paper presentation"
              (click)="removePaperPresentation(i)">x</button>
          }
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Conference</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(paper.get('conference')) }" formControlName="conference">
              @if (showError(paper.get('conference'))) {
                <span class="text-red-500 text-xs">{{ getTextError(paper.get('conference'), 'Conference') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Location</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(paper.get('location')) }" formControlName="location">
              @if (showError(paper.get('location'))) {
                <span class="text-red-500 text-xs">{{ getTextError(paper.get('location'), 'Location') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-start gap-4">
            <label class="text-sm font-medium text-slate-700 pt-2">Description</label>
            <div>
              <textarea class="textarea textarea-bordered w-full" rows="3" [ngClass]="{ 'error': showError(paper.get('description')) }" formControlName="description"></textarea>
              @if (showError(paper.get('description'))) {
                <span class="text-red-500 text-xs">{{ getTextError(paper.get('description'), 'Description') }}</span>
              }
            </div>
          </div>
        </div>
      }
      <div class="flex justify-end">
        <a (click)="addPaperPresentation()" class="cursor-pointer text-end block mt-2 text-xs font-semibold text-sky-700 hover:underline">Add More</a>
      </div>
    </div>
  </details>

  <details [open]="openSection === 'competitions'" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('competitions', $event)">
      <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
      Competitions
    </summary>
    <div class="mt-3 space-y-4" formArrayName="competitions">
      @for (competition of competitions.controls; track competition; let i = $index) {
        <div class="relative bg-zinc-100 border rounded-md p-6 space-y-4" [formGroupName]="i">
          @if (i > 0) {
            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove competition"
              (click)="removeCompetition(i)">x</button>
          }
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Competition</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(competition.get('competition')) }" formControlName="competition">
              @if (showError(competition.get('competition'))) {
                <span class="text-red-500 text-xs">{{ getTextError(competition.get('competition'), 'Competition') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Achievement</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(competition.get('achievement')) }" formControlName="achievement">
              @if (showError(competition.get('achievement'))) {
                <span class="text-red-500 text-xs">{{ getTextError(competition.get('achievement'), 'Achievement') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-start gap-4">
            <label class="text-sm font-medium text-slate-700 pt-2">Description</label>
            <div>
              <textarea class="textarea textarea-bordered w-full" rows="3" [ngClass]="{ 'error': showError(competition.get('description')) }" formControlName="description"></textarea>
              @if (showError(competition.get('description'))) {
                <span class="text-red-500 text-xs">{{ getTextError(competition.get('description'), 'Description') }}</span>
              }
            </div>
          </div>
        </div>
      }
      <div class="flex justify-end">
        <a (click)="addCompetition()" class="cursor-pointer text-end block mt-2 text-xs font-semibold text-sky-700 hover:underline">Add More</a>
      </div>
    </div>
  </details>

  <details [open]="openSection === 'certificates'" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('certificates', $event)">
      <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
      Certificates
    </summary>
    <div class="mt-3 space-y-4" formArrayName="certificates">
      @for (certificate of certificates.controls; track certificate; let i = $index) {
        <div class="relative bg-zinc-100 border rounded-md p-6 space-y-4" [formGroupName]="i">
          @if (i > 0) {
            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove certificate"
              (click)="removeCertificate(i)">x</button>
          }
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Certificate Title</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(certificate.get('title')) }" formControlName="title">
              @if (showError(certificate.get('title'))) {
                <span class="text-red-500 text-xs">{{ getTextError(certificate.get('title'), 'Certificate Title') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Institute</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(certificate.get('institute')) }" formControlName="institute">
              @if (showError(certificate.get('institute'))) {
                <span class="text-red-500 text-xs">{{ getTextError(certificate.get('institute'), 'Institute') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-start gap-4">
            <label class="text-sm font-medium text-slate-700 pt-2">Description</label>
            <div>
              <textarea class="textarea textarea-bordered w-full" rows="3" [ngClass]="{ 'error': showError(certificate.get('description')) }" formControlName="description"></textarea>
              @if (showError(certificate.get('description'))) {
                <span class="text-red-500 text-xs">{{ getTextError(certificate.get('description'), 'Description') }}</span>
              }
            </div>
          </div>
        </div>
      }
      <div class="flex justify-end">
        <a (click)="addCertificate()" class="cursor-pointer text-end block mt-2 text-xs font-semibold text-sky-700 hover:underline">Add More</a>
      </div>
    </div>
  </details>

  <details [open]="openSection === 'eventsOrganised'" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('eventsOrganised', $event)">
      <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
      Events Organised
    </summary>
    <div class="mt-3 space-y-4" formArrayName="eventsOrganised">
      @for (event of eventsOrganised.controls; track event; let i = $index) {
        <div class="relative bg-zinc-100 border rounded-md p-6 space-y-4" [formGroupName]="i">
          @if (i > 0) {
            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove event organised"
              (click)="removeEventOrganised(i)">x</button>
          }
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Event Title</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(event.get('title')) }" formControlName="title">
              @if (showError(event.get('title'))) {
                <span class="text-red-500 text-xs">{{ getTextError(event.get('title'), 'Event Title') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Role</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(event.get('role')) }" formControlName="role">
              @if (showError(event.get('role'))) {
                <span class="text-red-500 text-xs">{{ getTextError(event.get('role'), 'Role') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-start gap-4">
            <label class="text-sm font-medium text-slate-700 pt-2">Description</label>
            <div>
              <textarea class="textarea textarea-bordered w-full" rows="3" [ngClass]="{ 'error': showError(event.get('description')) }" formControlName="description"></textarea>
              @if (showError(event.get('description'))) {
                <span class="text-red-500 text-xs">{{ getTextError(event.get('description'), 'Description') }}</span>
              }
            </div>
          </div>
        </div>
      }
      <div class="flex justify-end">
        <a (click)="addEventOrganised()" class="cursor-pointer text-end block mt-2 text-xs font-semibold text-sky-700 hover:underline">Add More</a>
      </div>
    </div>
  </details>

  <details [open]="openSection === 'languagesKnown'" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('languagesKnown', $event)">
      <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
      Languages Known
    </summary>
    <div class="mt-3 space-y-4" formArrayName="languagesKnown">
      @for (language of languagesKnown.controls; track language; let i = $index) {
        <div class="relative bg-zinc-100 border rounded-md p-6 space-y-4" [formGroupName]="i">
          @if (i > 0) {
            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove language"
              (click)="removeLanguageKnown(i)">x</button>
          }
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Language Name</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(language.get('language')) }" formControlName="language">
              @if (showError(language.get('language'))) {
                <span class="text-red-500 text-xs">{{ getTextError(language.get('language'), 'Language Name') }}</span>
              }
            </div>
          </div>
        </div>
      }
      <div class="flex justify-end">
        <a (click)="addLanguageKnown()" class="cursor-pointer text-end block mt-2 text-xs font-semibold text-sky-700 hover:underline">Add More</a>
      </div>
    </div>
  </details>

  <details [open]="openSection === 'computerLiteracy'" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('computerLiteracy', $event)">
      <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
      Computer Literacy
    </summary>
    <div class="mt-3 space-y-4" formArrayName="computerLiteracy">
      @for (computerSkill of computerLiteracy.controls; track computerSkill; let i = $index) {
        <div class="relative bg-zinc-100 border rounded-md p-6 space-y-4" [formGroupName]="i">
          @if (i > 0) {
            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove computer literacy skill"
              (click)="removeComputerLiteracy(i)">x</button>
          }
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Skill</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(computerSkill.get('skill')) }" formControlName="skill">
              @if (showError(computerSkill.get('skill'))) {
                <span class="text-red-500 text-xs">{{ getTextError(computerSkill.get('skill'), 'Skill') }}</span>
              }
            </div>
          </div>
        </div>
      }
      <div class="flex justify-end">
        <a (click)="addComputerLiteracy()" class="cursor-pointer text-end block mt-2 text-xs font-semibold text-sky-700 hover:underline">Add More</a>
      </div>
    </div>
  </details>

  <div class="flex justify-end">
    <button type="submit" class="btn btn-primary" [disabled]="isSaving">
      {{ isSaving ? 'Saving...' : 'Save Co-curricular' }}
    </button>
  </div>
</form>
